import axios from "../../axios";

export function auth__login(email, password, role) {
    let cred = {
        email: email,
        password: password,
        role: role
    }
    return (async (dispatch) => {
        try {
            dispatch({ type: "USER_LOGIN_PENDING" });
            let response = await axios.post(`Endusers/login`, cred);
            dispatch({ type: "USER_LOGIN_FULFILLED", payload: { ...response.data, role: role } });
        }
        catch (err) {
            //console.log("Error.response :", err.response.data)
            if (err.response) {
                dispatch({
                    type: "USER_LOGIN_REJECTED", payload: {
                        error: err.response.data.error.name,
                        message: err.response.data.error.message,
                        code: err.response.data.error.statusCode
                    }
                });
            } else if (err) {
                dispatch({ type: "USER_LOGIN_REJECTED", payload: { error: "", message: "Login Failed", code: err.status } });
            } else {
                dispatch({ type: "USER_LOGIN_REJECTED", payload: { error: "", message: "Login Failed", code: err.status } });
            }
        }
    });
}
export function auth__logout() {
    return (async (dispatch) => {
        try {
            dispatch({ type: "USER_LOGOUT_PENDING" });
            let response = await axios.post(`Endusers/logout`);
            dispatch({ type: "USER_LOGOUT_FULFILLED", payload: response.data });
            dispatch({ type: "CLEAR_STORE", payload: null })
        }
        catch (err) {
            dispatch({ type: "USER_LOGOUT_REJECTED", payload: err.message });
        }
    });
}
export function auth__reset() {
    return (async (dispatch) => {
        try {
            dispatch({ type: "USER_LOGOUT_PENDING" });
            dispatch({ type: "USER_LOGOUT_FULFILLED" });
            dispatch({ type: "CLEAR_STORE", payload: null })
        }
        catch (err) {
            dispatch({ type: "USER_LOGOUT_REJECTED", payload: err.message });
        }
    });
}

export function auth__dismissAlert() {
    return {
        type: "USER_LOGON_DISMISS",
        payload: false
    }
}
export function auth__restoreLogon(logon) {
    return {
        type: "USER_LOGON_RESTORE",
        payload: logon
    }
}



// WEBPACK FOOTER //
// ./src/redux/actions/auth.js